import { onApiError } from "../error"
import { objectToQueryString } from "../utils"
import { del, get, put } from "./client"

/**
 * @param {string} imei
 */
async function deleteFencealarm2(imei) {
    const res = await del(`/fencealarm2s/${imei}`)
    if (!res.ok) throw await onApiError(res)
}

/**
 * @param {string} imei
 * @returns {Promise<Fencealarm2>}
 */
async function getFenceAlarm2(imei) {
    const res = await get(`/fencealarm2s/${imei}`)

    if (!res.ok) throw await onApiError(res)
    return res.json()
}


/**
 * @typedef {Object} VoltageDataPoint
 * @property {string} Imei
 * @property {number} Voltage
 * @property {string} Timestamp
 */

/**
 * @param {string} imei
 * @param {DataPointQueryParams} [args]
 * @returns {Promise<VoltageDataPoint[]|Blob>}
 */
async function getFencealarm2Voltage(imei, args) {
    const params = objectToQueryString(args)
    const res = await get(`/fencealarm2s/${imei}/voltage${params}`)

    if (!res.ok) throw await onApiError(res)
    if (!args || args.format !== "json") return res.blob()
    return res.json()
}

/**
 * @param {string} imei
 * @param {FlashFencealarm2Params} args
 */
async function putFencealarm2Fota(imei, args) {
    const res = await put(`/fencealarm2s/${imei}/fota`, {
        body: JSON.stringify(args)
    })

    if (!res.ok) throw await onApiError(res)
}

/**
 * @param {string} imei
 * @param {string} email
 * @returns {Promise<Fencealarm2>}
 */
async function putFencealarm2Owner(imei, email) {
    const res = await put(`/fencealarm2s/${imei}/owner`, {
        body: JSON.stringify({
            Email: email
        })
    })

    if (!res.ok) throw await onApiError(res)
    return res.json()
}

export {
    deleteFencealarm2,
    getFenceAlarm2,
    getFencealarm2Voltage,
    putFencealarm2Fota,
    putFencealarm2Owner,
}